import { useLocation, Link, useNavigate } from "react-router-dom"
import { IconCommand, IconSquarePlus, IconWorld, IconUsers, IconLogout, IconSelector } from "@tabler/icons-react"
import { NavLink, Stack, Group, ThemeIcon, Text, Avatar, Menu, UnstyledButton } from '@mantine/core';
import { useUserStore } from "../stores/userStore"
import { useState } from "react";
import { ContributorsModal } from "./contributors-modal";

export function AppSidebar() {
  const location = useLocation()
  const pathname = location.pathname
  const { user, clearUser } = useUserStore();
  const navigate = useNavigate();
  const [isContributorsModalOpen, setIsContributorsModalOpen] = useState(false);

  const navMain = [
    { title: "Dashboard", url: "/dashboard", icon: IconCommand },
    { title: "Generator", url: "/generator", icon: IconSquarePlus },
    { title: "Community", url: "/community", icon: IconWorld }
  ]

  if (user?.role === 'ADMIN') {
    navMain.push({ title: "Users", url: "/users", icon: IconUsers });
  }

  const getInitials = (name) => {
    if (!name) return "U";
    const names = name.split(" ")
    if (names.length > 1) {
      return `${names[0][0]}${names[names.length - 1][0]}`.toUpperCase()
    }
    return name.substring(0, 2).toUpperCase()
  }

  return (
    <Stack justify="space-between" h="100%">
      <Stack gap="xs">
        <Group px="xs" mb="md" align="center">
            <ThemeIcon size="lg" radius="md" color="cyan">
                <img src="/n-element.svg" alt="N-Element" style={{ width: 20, height: 20 }} />
            </ThemeIcon>
            <Text fw={700}>N-Element</Text>
        </Group>
        {navMain.map((item) => (
          <NavLink
            key={item.title}
            component={Link}
            to={item.url}
            label={item.title}
            leftSection={<item.icon size={16} />}
            active={pathname === item.url || (item.url !== '/dashboard' && pathname.startsWith(item.url))}
            variant="light"
            color="cyan"
            style={{ borderRadius: 'var(--mantine-radius-sm)' }}
          />
        ))}
      </Stack>
      
      <Stack gap="xs">
         <Text size="xs" c="dimmed" ta="center">Made with ❤️ by LoorCode AI</Text>
         
         <Menu shadow="md" width={200} position="right-end">
            <Menu.Target>
                <UnstyledButton
                    w="100%"
                    p="xs"
                    style={{
                        borderRadius: 'var(--mantine-radius-sm)',
                        transition: 'background-color 100ms ease'
                    }}
                    styles={{
                        root: {
                            '&:hover': {
                                backgroundColor: 'var(--mantine-color-gray-1)'
                            }
                        }
                    }}
                >
                    <Group align="center" wrap="nowrap">
                        <Avatar src={user?.avatar} radius="xl" size="sm" color="cyan">
                            {getInitials(user?.name)}
                        </Avatar>
                        <div style={{ flex: 1, minWidth: 0 }}>
                            <Text size="sm" fw={500} truncate>
                                {user?.name}
                            </Text>
                            <Text c="dimmed" size="xs" truncate>
                                {user?.email}
                            </Text>
                        </div>
                        <IconSelector size={14} style={{ flexShrink: 0 }} />
                    </Group>
                </UnstyledButton>
            </Menu.Target>

            <Menu.Dropdown>
                <Menu.Label>Account</Menu.Label>
                <Menu.Item leftSection={<IconUsers size={14} />} onClick={() => setIsContributorsModalOpen(true)}>
                    Contributors
                </Menu.Item>
                <Menu.Divider />
                <Menu.Item 
                    color="red" 
                    leftSection={<IconLogout size={14} />} 
                    onClick={() => {
                        clearUser();
                        navigate('/login');
                    }}
                >
                    Log out
                </Menu.Item>
            </Menu.Dropdown>
         </Menu>
      </Stack>
      <ContributorsModal isOpen={isContributorsModalOpen} setIsOpen={setIsContributorsModalOpen} />
    </Stack>
  );
}
